"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _index = require("@/api/education/index");
var _user = require("@/api/user/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return (0, _defineProperty2.default)((0, _defineProperty2.default)({
      title: "hello Word",
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称/编码"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "管理员姓名",
        prop: "name",
        isShow: true,
        width: "120"
      }, {
        name: "管理员账号",
        prop: "loginName",
        isShow: true,
        width: "120"
      },
      // { name: "所属学校", prop: "bureauName", isShow: true, width: "150" },
      {
        name: "邮箱",
        prop: "mail",
        isShow: true,
        width: "150"
      }, {
        name: "电话",
        prop: "phoneNumber",
        isShow: true,
        width: "150"
      }, {
        name: "更新时间",
        prop: "updateTime",
        isShow: true,
        width: "200",
        sortable: true
      }, {
        name: "创建时间",
        prop: "createTime",
        isShow: true,
        width: "200",
        sortable: true
      }],
      funBtns: [{
        size: "small",
        click: "deleteById",
        icon: "el-icon-delete",
        name: "批量删除",
        type: "danger"
      }, {
        size: "small",
        click: "resetPwd",
        icon: "el-icon-refresh",
        name: "重置密码",
        type: "primary"
      }, {
        size: "small",
        click: "add",
        icon: "el-icon-circle-plus-outline",
        name: "新增",
        type: "primary"
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      options: [{
        name: "编辑",
        class: "edit",
        option: "edit",
        span: 3
      }, {
        name: "删除",
        class: "delet",
        option: "deleteById",
        span: 3
      }],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      keyWords: ""
    }, "page", {
      pageNumber: 1,
      pageSize: 10
    }), "checkBoxs", []);
  },
  methods: {
    // 重置密码
    resetPwd: function resetPwd() {
      var _this = this;
      if (this.checkBoxs.length === 0) {
        this.$message.error("请先勾选数据，再进行操作。");
      } else if (this.checkBoxs.length > 1) {
        this.$message.error("当前仅支持单条数据的密码重置操作。");
      } else {
        (0, _user.resetPsd)({
          id: this.checkBoxs[0]
        }).then(function (res) {
          if (res.code === 2000) {
            _this.$message.success("操作成功。");
          }
        });
      }
    },
    // 获取教育局下的管理员
    getEducationAdminList: function getEducationAdminList() {
      var _this2 = this;
      (0, _index.getEducationAdmin)({
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize,
        id: this.$route.query.id,
        keyWords: this.keyWords
      }).then(function (res) {
        var data = res.data;
        _this2.listData = data.list;
        _this2.totalData = data.total;
      });
    },
    search: function search(e) {
      this.keyWords = e.queryValue;
      this.getschoolSys();
    },
    // 编辑
    edit: function edit(e) {
      console.log('pppp', e);
      this.$router.push({
        path: "/schoolTest/educationAdminAdd",
        query: {
          educationAdmin: e
        }
      });
    },
    // 新增
    add: function add() {
      this.$router.push({
        path: "/schoolTest/educationAdminAdd",
        query: {
          cityId: this.$route.query.id
        }
      });
    },
    // 删除
    deleteById: function deleteById(row) {
      var _this3 = this;
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据，再进行操作。");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _user.deleteUser)({
          idList: id
        }).then(function () {
          _this3.getEducationAdminList();
          _this3.$message.success("操作成功。");
        });
      }).catch(function () {
        _this3.$message.info("取消删除。");
      });
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var _this4 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this4.checkBoxs.push(item.id);
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getschoolSys();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getschoolSys();
    }
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  },
  created: function created() {
    this.getEducationAdminList();
    this.title = "所属教育局：" + this.$route.query.title;
  }
};